import { createAction } from '@reduxjs/toolkit';
export var setAppMode = createAction('AppMode/SET_APP_MODE');
export var setIsFetchPaymentMethodEnabled = createAction('AppMode/SET_FETCH_MOP_ENABLED_FLAG');


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/writing-checkout/node_modules/@chegg/payment-methods/dist/esm/redux/AppModeState/AppModeState.actions.js
// module id = 167
// module chunks = 11